
// @ts-nocheck


export const localeCodes =  [
  "es",
  "en"
]

export const localeLoaders = {
  "es": [],
  "en": []
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "__i18n_config_ts_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n.config.ts",
  "locales": [
    {
      "code": "es",
      "name": "Español",
      "iso": "es-US",
      "isCatchallLocale": true
    },
    {
      "code": "en",
      "name": "English",
      "iso": "en-US"
    }
  ],
  "defaultLocale": "es",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": null,
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "https://pfsrealty.com/",
  "dynamicRouteParams": false,
  "customRoutes": "config",
  "pages": {
    "index": {
      "en": "/",
      "es": "/"
    },
    "homes-and-condos/[...params]": {
      "en": "/homes-and-condos/[...params]",
      "es": "/casas-y-apartamentos/[...params]"
    },
    "new-projects/[...params]": {
      "en": "/new-projects/[...params]",
      "es": "/nuevos-proyectos/[...params]"
    },
    "blog/[...params]": {
      "en": "/blog/[...params]",
      "es": "/blog/[...params]"
    },
    "pfs/[slug]": {
      "en": "/pfs/[slug]",
      "es": "/pfs/[slug]"
    },
    "mortgage-calculator/index": {
      "en": "/mortgage-calculator",
      "es": "/calculadora-de-hipotecas"
    },
    "market-report/[...params]": {
      "en": "/market-report/[...params]",
      "es": "/reporte-de-mercado/[...params]"
    },
    "county/index": {
      "en": "/county",
      "es": "/condado"
    },
    "county/[name]/index": {
      "en": "/county/[name]",
      "es": "/condado/[name]"
    },
    "elite/index": {
      "en": "/elite",
      "es": "/elite"
    },
    "elite/info": {
      "en": "/elite/info",
      "es": "/elite/info"
    },
    "elite/thank-you": {
      "en": "/elite/thank-you",
      "es": "/elite/gracias"
    },
    "elite/reset-password": {
      "en": "/elite/reset-password",
      "es": "/elite/reiniciar-contrasena"
    },
    "account/index": {
      "en": "/account",
      "es": "/cuenta"
    },
    "account/profile": {
      "en": "/account/profile",
      "es": "/cuenta/perfil"
    },
    "account/saved-properties": {
      "en": "/account/saved-properties",
      "es": "/cuenta/propiedades-guardadas"
    },
    "account/saved-searches": {
      "en": "/account/saved-searches",
      "es": "/cuenta/busquedas-guardadas"
    },
    "account/notifications": {
      "en": "/account/notifications",
      "es": "/cuenta/notificaciones"
    },
    "account/reset-password": {
      "en": "/account/reset-password",
      "es": "/cuenta/reiniciar-contrasena"
    }
  },
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "es",
    "name": "Español",
    "iso": "es-US",
    "isCatchallLocale": true,
    "files": []
  },
  {
    "code": "en",
    "name": "English",
    "iso": "en-US",
    "files": []
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
